import { StateUtils } from '@spartacus/core';
import { AreaOfUse, AreaOfUseList } from '../../../../core/model/area-of-use.model';
import {
  AreaOfUseAdminActionTypes,
  LoadAreaOfUseListAdmin,
  LoadAreaOfUseListAdminFail,
  LoadAreaOfUseListAdminSuccess,
  ReplaceAreaOfUseAdminProductSuccess,
} from '../actions/area-of-use-admin.action';
import { AreaOfUseAdminListState } from '../area-of-use-admin-state';
import { getAllAreaOfUseCategories } from '../util/area-of-use-admin-utils';

export const areaOfUseAdminEntityInitialState = undefined;
export const areaOfUseAdminListInitialState = undefined;
export const areaOfUseProductsAddInitialState = undefined;
export const areaOfUseProductsRemoveInitialState = undefined;

export function areaOfUseAdminCategoriesReducer(
  state: AreaOfUse = areaOfUseAdminEntityInitialState,
  action: StateUtils.LoaderAction
): AreaOfUse {
  switch (action.type) {
    case AreaOfUseAdminActionTypes.LoadAreaOfUseCategoryAdminSuccess: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case AreaOfUseAdminActionTypes.EditAreaOfUseCategoryAdminSuccess: {
      return {
        ...state,
        ...action.payload.areaOfUse,
      };
    }
    case AreaOfUseAdminActionTypes.ExcludeArticlesFromAreaOfUseSuccess: {
      if (state.code === action.payload.categoryCode) {
        return {
          ...state,
          excludedArticleCodes: [...action.payload.excludedArticleCodes],
        };
      }

      return state;
    }
    case AreaOfUseAdminActionTypes.AddProductToAreaOfUseSuccess: {
      if (state.code === action.payload.categoryCode) {
        return {
          ...state,
          productCodes: [...(state.productCodes || []), action.payload.productCode],
        };
      }

      return state;
    }
    case AreaOfUseAdminActionTypes.RemoveProductsFromAreaOfUseSuccess: {
      if (state.code === action.payload.categoryCode) {
        return {
          ...state,
          productCodes: state.productCodes?.filter((productCode) => !action.payload.productCodes.includes(productCode)) || [],
        };
      }

      return state;
    }

    case AreaOfUseAdminActionTypes.ReplaceAreaOfUseAdminProductSuccess: {
      const _action = <ReplaceAreaOfUseAdminProductSuccess>action;
      const newProductCode = _action.newProductCode;
      const oldProductCode = _action.oldProductCode;
      const code = _action.code;

      if (state.code === code) {
        state = {
          ...state,
          productCodes: [...state.productCodes?.filter((productCode) => productCode !== oldProductCode), newProductCode],
        };
      }
      return state;
    }
  }
  return state;
}

export function areaOfUseAdminListReducer(
  state: AreaOfUseAdminListState = areaOfUseAdminListInitialState,
  action: LoadAreaOfUseListAdmin | LoadAreaOfUseListAdminFail | LoadAreaOfUseListAdminSuccess | StateUtils.LoaderAction
): AreaOfUseAdminListState {
  switch (action.type) {
    case AreaOfUseAdminActionTypes.LoadAreaOfUseListAdminSuccess: {
      const _action = <LoadAreaOfUseListAdminSuccess>action;
      const payload: AreaOfUseList = _action.payload;
      const allAreaOfUseCategories = getAllAreaOfUseCategories(payload.areasOfUse);
      const results = allAreaOfUseCategories.map((areaOfUse) => areaOfUse?.code);

      return {
        ...state,
        lastUpdateTime: new Date().toISOString(),
        results,
      };
    }
    case AreaOfUseAdminActionTypes.LoadAreaOfUseListAdminFail: {
      return {
        ...state,
        lastUpdateTime: new Date().toISOString(),
      };
    }
  }

  return state;
}
